import { Box, Grid2, Link, Typography } from '@mui/material';
import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

export default function About({ darkMode }) {
    return (
        <Grid2
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            height={`calc(100vh - 64px)`}
            textAlign="center"
            sx={{
                backgroundColor: darkMode ? '#0E0E0FC3' : '#FFFFFF88',
            }}
        >
            <Grid2 item xs={12} md={8}>
                <Box
                    component="section"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        margin: 2,
                    }}
                    maxWidth={800}
                >
                    <Box component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PlaceIcon fontSize="medium" />
                        <Typography variant="h6">São Carlos, São Paulo, Brasil</Typography>
                    </Box>

                    <Typography variant="h4" fontWeight={500}>
                        Olá, eu me chamo
                    </Typography>
                    <Typography variant="h3" fontWeight={500} marginTop={-1}>
                        Ítalo Matos
                    </Typography>
                    <Typography variant="h5" fontWeight={500} align="justify">
                        Sou um Desenvolvedor Fullstack apaixonado por projetar e implementar
                        soluções inovadoras e escaláveis. 👨‍💻
                    </Typography>
                </Box>
                <Box
                    component="div"
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 2,
                        marginX: 2,
                        marginTop: 8,
                        justifyContent: 'center',
                    }}
                >
                    <Link
                        variant="h2"
                        href="https://www.linkedin.com/in/italo-de-matos/"
                        sx={{ color: 'inherit' }}
                    >
                        <LinkedInIcon fontSize="h2" color="inherit" />
                    </Link>
                    <Link variant="h2" href="https://github.com/itMatos" sx={{ color: 'inherit' }}>
                        <GitHubIcon fontSize="h2" />
                    </Link>
                </Box>
            </Grid2>
        </Grid2>
    );
}
